export const CDN_URL = "https://media.cdn-gogive.com";
